import React from 'react';
import {
  Box,
  Card,
  CardContent,
  Typography,
  CircularProgress,
  Container,
} from '@mui/material';

interface InvitationProcessingProps {
  isAccepting: boolean;
  organisationName: string;
}

const InvitationProcessing: React.FC<InvitationProcessingProps> = ({
  isAccepting,
  organisationName,
}) => {
  if (!isAccepting) return null;

  return (
    <Container maxWidth="sm">
      <Box
        position="fixed"
        top={0}
        left={0}
        right={0}
        bottom={0}
        bgcolor="rgba(255, 255, 255, 0.9)"
        display="flex"
        alignItems="center"
        justifyContent="center"
        zIndex={9999}
      >
        <Card elevation={8} sx={{ minWidth: 300 }}>
          <CardContent sx={{ textAlign: 'center', p: 4 }}>
            <Box mb={2}>
              <CircularProgress size={60} thickness={4} />
            </Box>
            <Typography variant="h6" gutterBottom>
              Accepting Invitation
            </Typography>
            <Typography variant="body2" color="text.secondary" paragraph>
              Joining <strong>{organisationName}</strong>...
            </Typography>
            <Typography variant="caption" color="text.secondary">
              You&apos;ll be redirected automatically once complete.
            </Typography>
          </CardContent>
        </Card>
      </Box>
    </Container>
  );
};

export default InvitationProcessing;
